import { Typography } from "@/components/ui-v2";

type SectionTitleProps = {
  title: string;
};

export const SectionTitle = (props: SectionTitleProps) => {
  const { title } = props;

  return (
    <Typography letterSpacing={1} variant="micro" color="secondary.2">
      {title}
    </Typography>
  );
};
